export const ONE_CENT = 0.01
